import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

// --- New Service Functions for ProdukKonten ---

export const fetchProdukKontens = async ({ page = 1, per_page = 10, filters = {} }) => {
  try {
    const validatedPage = Math.max(1, parseInt(page) || 1);
    const validatedPerPage = Math.max(1, Math.min(100, parseInt(per_page) || 10));

    const params = {
      page: validatedPage,
      per_page: validatedPerPage,
      ...filters
    };

    const response = await axios.get(`${BASE_URL_BE}/produk-konten`, {
      headers: getAuthHeaders(),
      params: params,
      paramsSerializer: {
        indexes: null
      }
    });

    if (!response.data) {
      throw new Error('Invalid API response: missing data');
    }

    return {
      data: Array.isArray(response.data.data) ? response.data.data : [],
      meta: {
        page: response.data.meta?.page || validatedPage,
        per_page: response.data.meta?.per_page || validatedPerPage,
        total: response.data.meta?.total || 0,
        last_page: response.data.meta?.last_page || 1
      }
    };

  } catch (error) {
    console.error("Error fetching produk konten:", error);

    const errorMessage = error.response?.data?.message ||
      error.message ||
      'Failed to fetch produk konten data';

    const apiError = new Error(errorMessage);
    apiError.status = error.response?.status;
    apiError.details = error.response?.data?.errors || {};

    throw apiError;
  }
};

export const createProdukKonten = async (formData) => {
  try {
    const payload = {
      id_produk: parseInt(formData.id_produk, 10),
      id_tipe_konten: parseInt(formData.id_tipe_konten, 10),
      id_jenis_seleksi: formData.id_jenis_seleksi ? parseInt(formData.id_jenis_seleksi, 10) : null,
    };

    const response = await axios.post(`${BASE_URL_BE}/produk-konten`, payload, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating produk konten:", error);
    throw error;
  }
};

export const updateProdukKonten = async (id_produk_konten, formData) => {
  try {
    const payload = {
      id_produk: parseInt(formData.id_produk, 10),
      id_tipe_konten: parseInt(formData.id_tipe_konten, 10),
      id_jenis_seleksi: formData.id_jenis_seleksi ? parseInt(formData.id_jenis_seleksi, 10) : null,
    };

    const response = await axios.put(`${BASE_URL_BE}/produk-konten/${id_produk_konten}`, payload, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating produk konten:", error);
    throw error;
  }
};

export const deleteProdukKonten = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/produk-konten/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting produk konten:", error);

    if (error.response) {
      const apiError = new Error(error.response.data.message || 'Failed to delete produk konten');
      throw apiError;
    }

    throw error;
  }
};

export const getProdukKontenByID = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/produk-konten/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error getting produk konten by ID:", error);

    if (error.response) {
      const apiError = new Error(error.response.data.message || 'Failed to get produk konten');
      throw apiError;
    }

    throw error;
  }
};